var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("li", { ref: "li" }, [
    _c(
      "a",
      {
        attrs: { href: "" },
        on: {
          click: function ($event) {
            $event.preventDefault()
            return _vm.chooseCategory(_vm.item)
          },
        },
      },
      [_vm._v(_vm._s(_vm.item.name))]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/components/FacultyCategory.vue